import { CloseOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Row, Space } from 'antd';

import type { NRecords } from '@app/types';
import { generateKey } from '@app/utils';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

export const ScheduleDetails = ({
  data,
  hideTips,
}: {
  data: NRecords.ModelRecordTip[] | null;
  hideTips: () => void;
}) => {
  return (
    <>
      <Row justify="space-between" align="top">
        <Space className="records-title-and-icon" data-testid="records-title">
          <FontAwesomeIcon
            icon={'fa-solid fa-book' as IconProp}
            style={{ width: '15px', color: 'red' }}
          />
          <span>Записи:</span>
        </Space>
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined />}
          onClick={hideTips}
          data-testid="close-popup"
        />
      </Row>
      <ul className="records-container">
        {data?.map(({ TimeS, TimeE }, index) => {
          const [, handledStartTime] = TimeS.split('T');
          const [startHours, startMinutes] = handledStartTime.split(':');
          const [, handledEndTime] = TimeE.split('T');
          const [endHours, endMinutes] = handledEndTime.split(':');

          return (
            <li
              key={generateKey('ScheduleDetails', 'list-item', index)}
              data-testid="record-time"
            >
              {startHours}:{startMinutes}-{endHours}:{endMinutes}
            </li>
          );
        })}
      </ul>
    </>
  );
};
